import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import { config, ENV_VARS, STAGE } from 'ENV_CONFIG';

import createRootReducer from './root.reducer';
import { middleware } from './middleware';

const composeEnhancers =
  ENV_VARS.REACT_APP_STAGE !== STAGE.PROD &&
  ENV_VARS.REACT_APP_STAGE !== STAGE.TEST &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
      })
    : compose;

export const store = createStore(
  createRootReducer(config.history),
  composeEnhancers(applyMiddleware(routerMiddleware(config.history)), middleware),
);

// Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
if (ENV_VARS.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./root.reducer', () =>
    store.replaceReducer(createRootReducer(config.history)),
  );
}
